module.exports = "//public.zight.com/packs/media/images/onboarding/icons-check-bc2c673fa569ab2c96dd2977c367059e.svg";